import script from "./Footer-item.vue?vue&type=script&setup=true&lang=js"
export * from "./Footer-item.vue?vue&type=script&setup=true&lang=js"

import "./Footer-item.vue?vue&type=style&index=0&id=9c008a28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c008a28"]])

export default __exports__